// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"TextListA_thecomp__IvFPJ","swiperTool":"TextListA_swiperTool__qSe_O"};